import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    useMediaQuery,
    Theme,
} from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import NotificationListItem from './notification-item/notification-item.component';
import { Notification } from 'models/notification';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { permissions } from 'utils/permission';
import useFixMissingScroll from 'utils/use-fix-missing-scroll';

type NotificationListProps = {
    notifications: Notification[];
    onFetchMore: () => void;
    onNotificationDoneChanged?: () => void;
};
const NotificationList: FC<NotificationListProps> = ({
    notifications,
    onFetchMore,
    onNotificationDoneChanged,
}: NotificationListProps) => {
    const { t: translate } = useTranslation(['notifications']);
    const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
    const currentUser = currentUserVar();
    const isLabTechnician = permissions.isLabTechnician(currentUser.type);

    // Fix for infinite scroll not working on some screen sizes.
    useFixMissingScroll(onFetchMore, notifications?.length || 0);

    return (
        <Fragment>
            <TableContainer component={Paper}>
                <InfiniteScroll
                    dataLength={notifications ? notifications.length : 0}
                    next={onFetchMore}
                    throttleTimeInMs={75}
                    hasMore={true}
                    loader={undefined}
                >
                    <Table size={!isLargeScreen ? 'small' : 'medium'}>
                        <TableHead>
                            <TableRow>
                                <TableCell width="1"></TableCell>
                                {isLabTechnician && <TableCell width="1">{translate('notifications:DONE')}</TableCell>}
                                <TableCell>{translate('common:DATE')}</TableCell>
                                <TableCell>{translate('notifications:NOTIFICATION')}</TableCell>
                                <TableCell>{translate('notifications:SUBJECT')}</TableCell>
                                <TableCell>{translate('notifications:ORIGINATOR')}</TableCell>
                                {isLabTechnician ? <TableCell>{translate('common:CREATED_BY')}</TableCell> : undefined}
                                {isLabTechnician ? (
                                    <TableCell>{translate('notifications:NOTES')}</TableCell>
                                ) : undefined}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <Fragment>
                                {notifications.map((notification) => (
                                    <NotificationListItem
                                        key={notification._id}
                                        notification={notification}
                                        onDoneChanged={onNotificationDoneChanged}
                                    />
                                ))}
                            </Fragment>
                        </TableBody>
                    </Table>
                </InfiniteScroll>
            </TableContainer>
        </Fragment>
    );
};

export default NotificationList;
